import { throttle } from 'lodash';
import Cookies from 'js-cookie';

if (!window.dAgency) window.dAgency = {};

window.dAgency.initAnnouncementBar = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;
  const innerContainer = sectionContainer.querySelector(
    '.announcement-bar__container',
  );
  const backgroundContainer = sectionContainer.querySelector(
    '.announcement-bar__background',
  );
  if (!innerContainer || !backgroundContainer) return;

  const toggleAnnouncement = (close = true) => {
    var startHeight = '0px';
    var endHeight = `${innerContainer.clientHeight}px`;

    if (close) {
      startHeight = `${innerContainer.clientHeight}px`;
      endHeight = '0px';
      Cookies.set('announcement-closed', 'true', { expires: 7 });
    }
    const animation = sectionContainer.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 300,
        easing: 'ease-out',
      },
    );
    animation.onfinish = () => {
      backgroundContainer.classList.toggle('hidden');
      resizeCallback();
    };
  };

  const closeBtn = sectionContainer.querySelector('.announcement-bar__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', toggleAnnouncement);
    const announcementClosed = Cookies.get('announcement-closed');
    if (announcementClosed !== 'true') toggleAnnouncement(false);
  }

  const resizeCallback = throttle(
    () =>
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        `${sectionContainer.clientHeight}px`,
      ),
    500,
  );
  resizeCallback();
  window.addEventListener('resize', resizeCallback);

  if (
    innerContainer.classList.contains('announcement-bar__container--carousel')
  ) {
    const prevArrow = sectionContainer.querySelector(
      '.announcement-bar__arrow--left',
    );
    const nextArrow = sectionContainer.querySelector(
      '.announcement-bar__arrow--right',
    );

    const options = {
      loop: innerContainer.querySelectorAll('.swiper-slide').length >= 2,
      direction: innerContainer.dataset?.scrollDirection ?? 'horizontal',
      autoplay: {
        enabled: true,
        delay: 3000,
      },
      ...(prevArrow && nextArrow
        ? {
            navigation: {
              prevEl: prevArrow,
              nextEl: nextArrow,
            },
          }
        : {}),
    };

    new Swiper(innerContainer, options);
  } else if (
    innerContainer.classList.contains('announcement-bar__container--marquee')
  ) {
    const messagesWrapper = innerContainer.querySelector(
      '.announcement-bar__messages-wrapper',
    );
    if (!messagesWrapper) return;
    const messagesAccumulator = messagesWrapper.parentElement;
    const duplicationCount =
      Math.ceil(innerContainer.clientWidth / messagesWrapper.clientWidth) - 1;
    messagesAccumulator.appendChild(messagesWrapper.cloneNode(true));

    for (var i = 0; i < duplicationCount; i++) {
      messagesAccumulator.appendChild(messagesWrapper.cloneNode(true));
      messagesAccumulator.appendChild(messagesWrapper.cloneNode(true));
    }

    innerContainer.style.setProperty(
      '--animation-duration',
      `${Math.ceil(messagesAccumulator.clientWidth / 300)}s`,
    );
    messagesAccumulator.style.animationPlayState = `running`;
  }
};

if (document.readyState != 'loading') {
  [].forEach.call(document.querySelectorAll('.announcement-bar__container'), (el) => {
    window.dAgency.initAnnouncementBar(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.announcement-bar__container'), (el) => {
      window.dAgency.initAnnouncementBar(el);
    });
  });
}